import Signin from '@/components/authenticationPage/authentication/Signin';
import logo from '@/assets/logo.svg';
import useAmplitude from '@/hooks/useAmplitude';
import LanguageSetting from '@/ui/languageSetting';
import Signup from '@/components/authenticationPage/authentication/Signup';
import { useState } from 'react';

const SigninForm = () => {
  useAmplitude('signin');

  const [action, setAction] = useState<'signup' | 'signin'>('signin');

  return (
    <div className="grid min-h-svh sm:grid-cols-2">
      <div className="hidden sm:block bg-black relative overflow-hidden">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 text-white text-4xl font-regular w-full text-center z-20 animate-fade-in-delayed">
          <div className="flex justify-center gap-2 mb-10">
            <img src={logo} alt="logo" width="60px" />
            <div className="flex flex-col justify-center">
              <span className="font-medium leading-tight">ESG LENS</span>
              <span className="text-white/50 text-sm leading-tight text-left ml-0.5">
                by FAIRLABS
              </span>
            </div>
          </div>
          <span className="text-white text-3xl w-full text-center z-20">
            AI-Powered ESG Insights
          </span>
        </div>
        <video
          src={process.env.PUBLIC_URL + '/loop.mp4'}
          autoPlay
          loop
          muted
          playsInline
          ref={(el) => {
            if (el) el.playbackRate = 0.4;
          }}
          className="absolute top-0 left-1/2 -translate-x-1/2 translate-y-[40%] object-cover w-full scale-[1.5] blur animate-fade-in"
        />
      </div>
      <div className="p-6 md:p-10 relative max-h-dvh overflow-y-auto flex flex-col justify-center">
        <div className="fixed top-0 right-0 m-6">
          <LanguageSetting />
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            {action === 'signin' ? (
              <Signin onRegister={() => setAction('signup')} />
            ) : (
              <Signup onSignin={() => setAction('signin')} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigninForm;
